import { FormEvent, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export default function ProfilePage() {
  const { user, profile, refreshProfile } = useAuth();
  const [displayName, setDisplayName] = useState(profile?.display_name || '');
  const [nickname, setNickname] = useState(profile?.nickname || '');
  const [stats, setStats] = useState({ participated: 0, won: 0, bids: 0 });
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    setDisplayName(profile?.display_name || '');
    setNickname(profile?.nickname || '');
  }, [profile]);

  useEffect(() => {
    if (!user) return;
    const loadStats = async () => {
      const [participants, won, bids] = await Promise.all([
        supabase.from('auction_participants').select('auction_id', { count: 'exact', head: true }).eq('user_id', user.id),
        supabase.from('auctions').select('id', { count: 'exact', head: true }).eq('current_winner_id', user.id).neq('status', 'open'),
        supabase.from('bids').select('id', { count: 'exact', head: true }).eq('user_id', user.id)
      ]);
      setStats({ participated: participants.count || 0, won: won.count || 0, bids: bids.count || 0 });
    };
    loadStats();
  }, [user]);

  const save = async (event: FormEvent) => {
    event.preventDefault();
    if (!user) return;
    const { error } = await supabase.from('profiles').update({
      display_name: displayName.trim(),
      nickname: nickname.trim()
    }).eq('id', user.id);
    if (error) setMessage(error.message);
    else {
      await refreshProfile();
      setMessage('Profilo aggiornato.');
    }
  };

  return (
    <div className="page-stack narrow">
      <section className="panel">
        <span className="eyebrow">Il tuo profilo</span>
        <h1>{profile?.display_name || profile?.nickname || user?.email}</h1>
        <div className="detail-stats profile-stats">
          <div><span>Aste partecipate</span><strong>{stats.participated}</strong></div>
          <div><span>Aste vinte</span><strong>{stats.won}</strong></div>
          <div><span>Offerte effettuate</span><strong>{stats.bids}</strong></div>
        </div>

        <form className="form-stack" onSubmit={save}>
          <label>Nome visualizzato<input value={displayName} onChange={(e) => setDisplayName(e.target.value)} /></label>
          <label>Nickname<input value={nickname} onChange={(e) => setNickname(e.target.value)} /></label>
          <button className="primary-button full">Salva profilo</button>
          {message && <p className="message-box">{message}</p>}
        </form>
      </section>
    </div>
  );
}
